export default "__VITE_ASSET__4eb23acf__"